<template>
  <LocalGrouperServiceForm
    ref="form"
    enable-row-id
    v-bind="$attrs"
    :enable-view-picker="false"
    row-id-label="localGrouperDeleteRowServiceForm.rowIdLabel"
    row-id-placeholder="localGrouperDeleteRowServiceForm.rowIdPlaceholder"
    :row-id-helper-text="
      $t('localGrouperDeleteRowServiceForm.rowIdHelper', {
        limit: batchOperationSizeLimit,
      })
    "
  />
</template>

<script>
import LocalGrouperServiceForm from '@grouper/modules/integrations/localGrouper/components/services/LocalGrouperServiceForm'

export default {
  name: 'LocalGrouperDeleteRowServiceForm',
  components: {
    LocalGrouperServiceForm,
  },
  computed: {
    batchOperationSizeLimit() {
      return this.$config.public.integrationLocalGrouperBatchOperationSizeLimit
    },
  },
  methods: {
    isFormValid() {
      return this.$refs.form.isFormValid()
    },
  },
}
</script>
